import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Loader2, ImageOff, X } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import api, { resolveImg } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import PageHeader from "@/components/PageHeader";

const Galeri = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);
  useSeo("Galeri", "Dokumentasi kegiatan Madrasah Ibtidaiyah Futuhiyyah Doro, Pekalongan.");

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="Galeri Dokumentasi" subtitle="Kumpulan momen dan dokumentasi kegiatan di MI Futuhiyyah Doro." crumbs={[{ label: "Galeri" }]} />
      <div className="mx-auto max-w-6xl px-6 py-14">
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>
        ) : items.length === 0 ? (
          <div className="py-20 text-center text-slate-400" data-testid="gallery-empty-state">
            <ImageOff className="mx-auto h-12 w-12 opacity-40" />
            <p className="mt-3">Belum ada foto di galeri.</p>
          </div>
        ) : (
          <div className="columns-2 gap-4 sm:columns-3 lg:columns-4 [&>*]:mb-4">
            {items.map((g, i) => (
              <motion.button
                key={g.id}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3, delay: i * 0.03 }}
                onClick={() => setActive(g)}
                data-testid={`gallery-item-${g.id}`}
                className="group relative block w-full overflow-hidden rounded-xl"
              >
                <img src={resolveImg(g.image_url)} alt={g.title} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/60 to-transparent p-3 opacity-0 transition-opacity group-hover:opacity-100">
                  <p className="text-xs font-medium text-white">{g.title}</p>
                </div>
              </motion.button>
            ))}
          </div>
        )}
      </div>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent className="max-w-3xl p-2" data-testid="gallery-lightbox">
          {active && (
            <div>
              <img src={resolveImg(active.image_url)} alt={active.title} className="w-full rounded-lg object-contain" />
              <p className="py-3 text-center text-sm font-medium text-slate-600">{active.title}</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Galeri;
